/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
const INITIAL_CONTEXT = {
  idle: {},
  REINVITE_USER: {},
};

const MACHINE_CONFIG = {
  id: 'io.vlinder.klefki.delete.draft',
  initial: 'idle',
  context: INITIAL_CONTEXT,
  states: {
    idle: {
      entry: ['resetAction'],
      on: {
        START: { target: 'REINVITE_USER' },
      },
    },
    REINVITE_USER: {
      invoke: {
        id: 'reinviteUser',
        src: 'reinviteUser',
        onDone: {
          target: 'REINVITE_USER_SUCCESS',
          actions: ['successAction'],
        },
        onError: {
          target: 'REINVITE_USER_FAILED',
          actions: ['failureAction'],
        },
      },
    },
    REINVITE_USER_SUCCESS: {
      on: {
        START: { target: 'REINVITE_USER' },
      },
    },
    REINVITE_USER_FAILED: {
      on: {
        START: { target: 'REINVITE_USER' },
      },
    },
  },
};

//Machine(MACHINE_CONFIG)

export { INITIAL_CONTEXT, MACHINE_CONFIG };
